import { defaultHttpClient } from '../../httpClient';

interface GetGoodsReportableResponse {
  is_reportable: boolean;
}

export const getGoodsReportable = (goodsSno: number) => {
  return defaultHttpClient
    .request<GetGoodsReportableResponse>({
      method: 'GET',
      url: `/api/v2/reports/goods/${goodsSno}/`,
    })
    .then(result => result.data.is_reportable ?? false);
};
